import { baseApi } from "../baseApi";

type AvailabilitySummary = {
  id: number;
  num_of_movers: number;
  num_of_trucks: number;
  service_date: string;
  service: string;
  start_window_begin_hour: number;
  start_window_begin_minute: number;
  start_window_begin_meridiem: "AM" | "PM";
  start_window_end_hour: number;
  start_window_end_minute: number;
  start_window_end_meridiem: "AM" | "PM";
  hours_estimate: number;
  kind: string;
  num_of_rooms: number;
  origin: { city: string };
  destination: { city: string };
};

const movesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchCustomer: builder.query({
      query: (query) => `customers/search?query=${query}`,
    }),

    searchMove: builder.query({
      query: (query) => `moves/search?query=${query}`,
    }),

    getMoves: builder.query({
      query: ({
        type,
        filters,
        after,
        before,
        page = 1,
        sort,
        limit,
        include = [],
      }) => {
        const path = `moves/${type}`;
        const params = {
          page,
          filters,
          after,
          before,
          sort,
          limit,
          include: include.join(","),
        };

        return {
          url: path,
          params,
        };
      },
    }),

    // returns everything in the move
    getMove: builder.query({
      query: (id) => `moves/${id}`,
    }),

    createMove: builder.mutation({
      query: (move) => ({
        url: "moves",
        method: "POST",
        body: move,
      }),
    }),

    updateMove: builder.mutation({
      query: ({ id, move }) => ({
        url: `moves/${id}`,
        method: "PUT",
        body: move,
      }),
    }),

    cloneMove: builder.mutation({
      query: ({ id, data }) => ({
        url: `moves/${id}/clone`,
        method: "POST",
        body: data,
      }),
    }),

    moveActions: builder.mutation({
      query: ({ id, action, data = {} }) => {
        const params = {
          op: action,
        };

        return {
          url: `moves/${id}/actions`,
          method: "POST",
          params,
          body: data,
        };
      },
    }),

    getAvailability: builder.query<AvailabilitySummary[], string>({
      query: (date) => `moves/availability?date=${date}`,
    }),

    getCrewAvailability: builder.query({
      query: (id) => `moves/${id}/crew/availability`,
    }),

    updateCrew: builder.mutation({
      query: ({ id, crew }) => ({
        url: `moves/${id}/crew`,
        method: "PATCH",
        body: crew,
      }),
    }),

    applyTemplate: builder.mutation({
      query: ({ id, templateId }) => ({
        url: `moves/${id}/apply-template`,
        method: "POST",
        body: { template_id: templateId },
      }),
    }),

    getCanceledJobs: builder.query({
      query: ({
        page = 1,
        sort = "service_date desc",
        limit = 50,
        include = [],
      }) => {
        const params = {
          page,
          sort,
          limit,
          include: include.join(","),
        };

        return {
          url: "moves/canceled_jobs",
          params,
        };
      },
    }),

    // deleteMove: builder.mutation({
    //   query: (id) => ({
    //     url: `moves/${id}`,
    //     method: "DELETE",
    //   }),
    // }),

    // You can add more endpoints as needed, such as:
    // addCustomerToMove, updateMoveStatus, etc.
  }),
});

export const {
  useGetMovesQuery,
  useGetMoveQuery,
  useGetAvailabilityQuery,
  useGetCrewAvailabilityQuery,
  useSearchCustomerQuery,
  useSearchMoveQuery,
  useCreateMoveMutation,
  useUpdateMoveMutation,
  useCloneMoveMutation,
  useMoveActionsMutation,
  useUpdateCrewMutation,
  useApplyTemplateMutation,
  useGetCanceledJobsQuery,
  // useDeleteMoveMutation,
} = movesApi;
